import { render, staticRenderFns } from "./TableUsers.vue?vue&type=template&id=533a4c5b&"
import script from "./TableUsers.vue?vue&type=script&lang=js&"
export * from "./TableUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports